import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-progress-step',
  templateUrl: './progress-step.component.html',
  styleUrls: ['./progress-step.component.scss']
})
export class ProgressStepComponent {
  public stepIndex!: number;

  @HostBinding('class.activeStep') public isActive = false;

  @Input() public set activeState(step:any){
    this.isActive = step === this
  }

}